import { request as getAllRelatedContingency } from './reducers/get-all-related-contingency';
import { request as createRelatedContingency } from './reducers/create-related-contingency';
import { request as updateRelatedContingency } from './reducers/update-related-contingency';
import { request as addMarketsToTag } from './reducers/add-markets';
import { request as getMarketsForTag } from './reducers/get-markets-for-rc-tag';
import { request as deleteMarketFromTag } from './reducers/remove-market-from-tag';
import { request as getEventInfoByTagId } from './reducers/get-event-info';

// eslint-disable-next-line import/no-default-export
export default {
    GET_RELATED_CONTINGENCY_REQUEST: getAllRelatedContingency,
    CREATE_RELATED_CONTINGENCY_REQUEST: createRelatedContingency,
    UPDATE_RELATED_CONTINGENCY_REQUEST: updateRelatedContingency,
    ADD_MARKETS_TO_TAG_REQUEST: addMarketsToTag,
    GET_MARKETS_FOR_TAG_REQUEST: getMarketsForTag,
    DELETE_MARKET_FROM_TAG_REQUEST: deleteMarketFromTag,
    GET_EVENT_INFO_BY_CONTINGENCY_ID_REQUEST: getEventInfoByTagId,
};
